<template>
    <!-- Footer Start -->
    <div class="container-fluid bg-green text-white footer">
        <div class="container wow fadeIn" data-wow-delay="0.1s">
            <div class="copyright">
                <div class="row">
                    <div class="col-12 text-center mb-3 mb-md-0">
                        <div class="col-12">Follow Us<a class="btn pl-0" href="https://www.instagram.com/nadboost/"><i
                                    class="fab fa-instagram-square fa-2xl"></i> @nadboost</a></div>
                        <div class="col-12">Copyright &copy; {{ currentYear }} <a href="/" target="_blank">Bio NAD+
                                Boost</a></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Footer End -->
    <!-- Back to Top -->
    <a :href="'http://wa.me/' + noTelp + '?text=' + FooterComp.wa" target="_blank"><button type="button"
            class="btn btn-success btn-whatsapp"><img
                v-bind:src="'https://api.bisnisonlinebgs.com/uploads/images/icon/whatsapp-icon-trans.png'"
                width="35"></button></a>
    <a href="#" class="btn btn-lg btn-primary btn-lg-square back-to-top"><i class="bi bi-arrow-up"></i></a>
</template>

<script>
import axios from 'axios'

export default {
    name: 'FooterComp',

    data() {
        return {
            currentYear: new Date().getFullYear(),
            noTelp: '62811959901',
            show: false,
            FooterComp: {
                wa: null
            }
        }
    },

    mounted() {
        // this.username = window.location.pathname.replace("/", "");
        // console.log(this.username)
        this.username = this.$route.params.username
        if (this.username) {
            axios
                .get(`https://api.bisnisonlinebgs.com/api/content/member/getMemberById/${this.username}`)
                .then(response => {
                    this.noTelp = response.data.data[0].mobile_no
                    // console.log(response.data.data[0].mobile_no)
                });
        }

        axios.get(`../../lang.json`).then(response => {
            let dataFooterComp
            if (localStorage.getItem('lang_nad') == 'id') {
                dataFooterComp = response.data.id[0];
            } else if (localStorage.getItem('lang_nad') == 'en') {
                dataFooterComp = response.data.en[0];
            }
            this.FooterComp.wa = dataFooterComp.FooterComp.wa
        })

        window.addEventListener('scroll', this.onScroll)
    }
}

</script>
